import { EasyAnalyticsConfig } from './easy-analytics.config';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EasyNgxGoogleAnalyticsComponent } from './easy-ngx-google-analytics.component';



export class EasyNgxGoogleAnalyticsModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    EasyNgxGoogleAnalyticsComponent,
  ],
  exports: [
    EasyNgxGoogleAnalyticsComponent,
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
